













































import { Component, Vue } from 'vue-property-decorator';
import createLeagueService from '../../services/CreateLeagueService';

@Component({
    components: {
    },
})
export default class CreateLeagueStep2 extends Vue {
    private participants = 1;
    private price = 5;
    private serie_start = 0;
    private serie_end = 0;
    private series = [];

    private async mounted() {
        this.series = await createLeagueService.fetchSeries();
    }

    private update() {
        this.$emit("updateLeague", [
            {
                key: "participants",
                value: this.participants
            },
            {
                key: "price",
                value: this.price
            },
            {
                key: "serie_start",
                value: this.serie_start
            },
            {
                key: "serie_end",
                value: this.serie_end
            }
        ])
    }

}
